import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import Pages from '../Rubrics/Pages'
import Loader from '../UI/Loader'
import tools from '../../tools'

// Niveau 3 du drill-down /contenu : l'éditeur d'une page seule (sans catégorie), rhabillé (maquette v6)
class ContenuPage extends Component {
	constructor(props) {
		super(props)
		this.state = {
			page: null,
			icons: null,
			theme: null,
			current_lang: this.props.lang_default,
			not_found: false,
			error: null
		}
		this.props.updateNavbarTitle('Contenu de mon app')
	}

	componentDidMount() {
		this.loadPage()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.id !== this.props.match.params.id)
		{
			this.setState({ page: null, not_found: false, error: null })
			this.loadPage()
		}
	}

	loadPage = () => {
		const page_id = this.props.match.params.id
		Promise.all([
			this.props.fetchPageByID(page_id),
			this.props.fetchIcons(),
			this.props.fetchTheme()
		])
		.then(([page, icons, theme]) => {
			if (!page)
			{
				this.setState({ not_found: true })
				return ;
			}
			this.setState({ page: page, icons: icons, theme: theme })
		})
		.catch(err => {
			this.setState({ error: tools.default_error_msg("Impossible de récupérer la page", 1) })
			console.log(err)
		})
	}

	updateLang = (lang) => {
		this.setState({ current_lang: lang })
	}

	goContenu = () => {
		this.props.history.push('/contenu')
	}

	render() {
		const permissions = this.props.user.permissions
		if (!permissions || !permissions.rubrics || permissions.rubrics === 0)
			return (<Redirect to="/" />)
		if (this.state.not_found === true)
			return (<Redirect to="/contenu" />)
		if (this.state.page === null)
		{
			if (this.state.error !== null)
				return (<p className="error center">{this.state.error}</p>)
			return (
				<div className="loader">
					<Loader />
				</div>
			)
		}
		const name = tools.getTranslationValue(this.state.page.translations, this.props.lang_default, 'name')
		return (
			<div className="wrapper-content">
				<p className="text-xs text-gray-400 mb-4 max-w-4xl">
					<Link to="/contenu" className="text-gray-500 hover:text-gray-900">Contenu de mon app</Link>
					<span className="mx-2 text-gray-300">/</span>
					<span className="text-gray-900 font-semibold">{name}</span>
				</p>
				<div className="flex items-center flex-wrap max-w-4xl mb-5">
					<div className="w-11 h-11 rounded-xl flex-shrink-0 flex items-center justify-center bg-green-50 text-green-600">
						<span className="text-base" aria-hidden="true">▭</span>
					</div>
					<div className="flex-1 min-w-0 ml-4">
						<h2 className="text-lg font-bold tracking-tight text-gray-900 mb-0 truncate">{name}</h2>
						<p className="mt-1 mb-0">
							<span className="inline-flex items-center text-xs font-semibold bg-green-50 text-green-700 rounded-full px-3 py-1">
								<span className="w-1.5 h-1.5 rounded-full bg-green-500 mr-1.5" aria-hidden="true"></span>Page seule
							</span>
						</p>
					</div>
				</div>
				<Pages
					embedded={true}
					page={this.props.match.params.id}
					navigation={[]}
					current_lang={this.state.current_lang}
					features={this.props.features}
					icons={this.state.icons}
					langs={this.props.langs}
					lang_default={this.props.lang_default}
					pages={this.props.pages}
					services={this.props.services}
					theme={this.state.theme}
					fetchPageByCategory={this.props.fetchPageByCategory}
					fetchPageByID={this.props.fetchPageByID}
					fetchServices={this.props.fetchServices}
					insertPageSection={this.props.insertPageSection}
					updatePageCover={this.props.updatePageCover}
					updatePageDuplicateSection={this.props.updatePageDuplicateSection}
					updatePageOrderSections={this.props.updatePageOrderSections}
					updatePageSection={this.props.updatePageSection}
					updatePageService={this.props.updatePageService}
					deletePageSection={this.props.deletePageSection}
					deletePageService={this.props.deletePageService}
					updateLang={this.updateLang}
					unShowGroup={this.goContenu}
					unShowCategory={this.goContenu}
					unShowList={this.goContenu}
				/>
			</div>
		)
	}
}

export default ContenuPage
